import styled from 'styled-components';

export const WrapperInputText = styled.div`
  flex: 1;
`;
